/* tslint:disable */

import { ComponentLinkType } from './ComponentLinkType';
import { ComponentLinkValueDto } from './ComponentLinkValueDto';
import { ComponentState } from './ComponentState';
import { UserDto } from './UserDto';

export class ComponentLinkDto {
  fromComponentCode?: string;
  fromComponentVersion?: string;
  toComponentCode?: string;
  toComponentVersion?: string;
  defaultLanguageCode?: string;
  fromComponentTitle?: string;
  toComponentTitle?: string;
  toComponentState?: ComponentState;
  createdAt?: any;
  updatedAt?: any;
  createdById?: string;
  createdBy?: UserDto;
  updatedById?: string;
  updatedBy?: UserDto;
  linkType?: ComponentLinkType;
  values?: ComponentLinkValueDto[];
}
